<template>
  <div id="index">
    <el-container>
      <div class="rightSide" style="top: 0; left: 0">
        <el-header class="Large-Header">
          <img src="~/assets/img/Loginlogo.png" />
          <span>
            {{ activeLang == 'en' ? projectNameEn : projectName }} {{ $t("title.staionMonitor") }}
            <!-- <small>Air Compressor IoT Management Platform</small> -->
          </span>
          <div class="Large-language">
            <el-button @click="changeLanguage('zh')" round
              :class="activeLang == 'zh' ? 'selected' : ''">简体中文</el-button>
            <el-button @click="changeLanguage('en')" round
              :class="activeLang == 'en' ? 'selected' : ''">English</el-button>
            <el-button class="backHome" icon="el-icon-s-home" v-on:click="retHome()"  v-if="showBackHomeButton"></el-button>
          </div>
        </el-header>
        <el-main class="index Large-index">
          <el-row>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" style="position: relative">
              <el-row>
                <el-col :xs="6" :sm="6" :md="6" :lg="6">
                  <el-row>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24">
                      <div class="homeCon titleBgColor">
                        <h4 class="BoxTitle">
                          {{ translate["sumFlow"] }}
                          <span class="fr">{{ formatNumber(sumFlow) }} m³</span>
                        </h4>
                      </div>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24">
                      <div class="homeCon titleBgColor">
                        <h4 class="BoxTitle">
                          {{ translate["sumBattery"] }}
                          <span class="fr">{{ formatNumber(sumBattery) }} kWh</span>
                        </h4>
                      </div>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24">
                      <div class="homeCon titleBgColor">
                        <h4 class="BoxTitle" style="overflow: hidden;">
                          {{ translate["sumFlowPowerRatio"] }}
                          <span class="fr">{{ sumFlowPowerRatio }} kWh/m³</span>
                        </h4>
                      </div>
                    </el-col>

                    <el-col :xs="24" :sm="24" :md="24" :lg="24">
                      <div class="homeCon homeConOpacity">
                        <h4 class="BoxTitle">
                          {{ translate["flowTrend"] }}
                        </h4>
                        <div id="flowTrend" :style="lineChartHeight"></div>
                      </div>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24">
                      <div class="homeCon homeConOpacity">
                        <h4 class="BoxTitle">
                          {{ translate["powerTrend"] }}
                        </h4>
                        <div id="powerTrend" :style="lineChartHeight"></div>
                      </div>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24">
                      <div class="homeCon homeConOpacity">
                        <h4 class="BoxTitle">
                          {{ translate["flowPowerRatioTrend"] }}
                        </h4>
                        <div id="flowPowerRatioTrend" :style="lineChartHeight"></div>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>

                <el-col :span="12">
                  <el-row>
                    <img :src="scadaImg" loading="lazy" alt="站房三维图" class="custom-height-img" ref="img" />
                  </el-row>
                  <div class="card-carousel-container">
                    <h4 class="BoxTitle">
                      {{ translate["threeTrend"] }}
                    </h4>
                    <div id="threeTrend" style="height: 260px;"></div>
                  </div>

                </el-col>

                <el-col :xs="6" :sm="6" :md="6" :lg="6" style="float: right">
                  <el-row>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24">
                      <div class="homeCon titleBgColor">
                        <h4 class="BoxTitle">
                          {{ translate["avgDewPoint"] }}
                          <span class="fr">{{ avgDewPoint }} °C</span>
                        </h4>
                      </div>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24">
                      <div class="homeCon titleBgColor">
                        <!-- <h4 class="BoxTitle" style="display: flex; justify-content: space-between; align-items: center;"> -->
                        <h4 class="BoxTitle" style="overflow: hidden;">
                          {{ translate["avgSpecificPowerRatio"] }}
                          <span class="fr">{{ formatNumber(avgSpecificPowerRatio) }} kW/(m³/min)</span>
                        </h4>
                      </div>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24">
                      <div class="homeCon titleBgColor">
                        <h4 class="BoxTitle">
                          {{ translate["avgPressure"] }}
                          <span class="fr">{{ avgPressure }} bar</span>
                        </h4>
                      </div>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24">
                      <div class="homeCon homeConOpacity">
                        <h4 class="BoxTitle">
                          {{ translate["dewPointTrend"] }}
                        </h4>
                        <div id="dewPointTrend" :style="lineChartHeight"></div>
                      </div>
                    </el-col>

                    <el-col :xs="24" :sm="24" :md="24" :lg="24">
                      <div class="homeCon homeConOpacity">
                        <h4 class="BoxTitle">
                          {{ translate["specificPowerRatioTrend"] }}
                        </h4>
                        <div id="specificPowerRatioTrend" :style="lineChartHeight"></div>
                      </div>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24">
                      <div class="homeCon homeConOpacity">
                        <h4 class="BoxTitle">
                          {{ translate["pressureTrend"] }}
                        </h4>
                        <div id="pressureTrend" :style="lineChartHeight"></div>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-main>
      </div>
    </el-container>
  </div>
</template>

<script type="text/javascript">
import * as echarts from "echarts";
import "assets/eCharts/world_new.js";
import {
  // getStationProjectList,
  // getMonitorItemList,
  // getAvgPressureRangeData,
  // getAvgFlowRangeData,
  // getSumFlowByDay,
  // getSumPowerByDay,
  // getElectricitySaving,
  getProjectMonitorData,
  getFlowTrendByProject,
  getPressureTrendByProject,
  getPowerTrendByProject,
  getDewPointTrendByProject,
  getSumFlowByProject,
  getSumPowerByProject,
  getSumBatteryByProject,
  getAvgPressureByProject,
  getAvgDewPointByProject,
  getAvgSpecificPowerRatioByProject,
  getSpecificPowerTrendByProject,
  getFlowPowerRatioTrendByProject,
  getSumFlowPowerRatioByProject,
  getFlowStatisticsThrendByProject,
  getPowerStatisticsThrendByProject,
  getUnitConsumptionStatisticsThrendByProject,
  getStationinfo,
  // getThreeTrendByProject,
} from "../../api/api";
import { mapCoordinate } from "../../mixins/mapCoordinate";
import { multiTranslate } from "../../mixins/multiTranslate";
import { mapMutations, mapGetters } from "vuex";
import { name } from "file-loader";

export default {
  name: "Index",
  ...mapMutations(["setLanguage", "setMultiLanguage"]),
  mixins: [mapCoordinate, multiTranslate],
  data() {
    return {
      showBackHomeButton: true,
      translate: {},
      mapHeight: {
        height: "",
        minHeight: "645px",
      },
      lineChartHeight: {
        height: "",
        minHeight: "80px",
      },
      cardHeight: {
        height: "100px",
        minHeight: "80px",
        width: "100%",
        // marginBottom: "0px",
      },
      insightStatList: [],
      mapProvinceData: [],
      mapCityData: [],
      totalShipmentCount: 0,
      registerRate: 0,
      onlineRate: 0,
      offlineRate: 0,
      warningCount: 0,
      tripCount: 0,
      utilizationRate: 0,
      tableCustomer: [],
      registTotal: [],
      onlineTotal: [],
      offlineTotal: [],
      TripData: [],
      WarningData: [],
      UtlizationData: [],
      classifyNumObj: {},
      flowTrendByProject: [],
      pressureTrendByProject: [],
      powerTrendByProject: [],
      dewPointTrendByProject: [],


      specificPowerRatioTrendByProject: [],
      avgSpecificPowerRatio: null,
      flowPowerRatioTrendByProject: [],
      sumFlowPowerRatio: null,

      sumFlow: null,
      sumPower: null,
      sumBattery: null,
      avgPressure: null,
      avgDewPoint: null,
      projectId: null,
      projectName: null,
      echatsNoDataOption: {
        graphic: {
          elements: [
            {
              type: 'text',
              style: {
                text: 'No Data',
                font: 'bolder 16px Microsoft YaHei',
                fill: '#ddd', // 文字颜色
              },
              left: 'center', // 水平居中
              top: 'middle', // 垂直居中
            },
          ],
        },
      },
      scadaImg: '',
    };
  },
  created: function () {
    let lang = window.localStorage.getItem("user_lang");
    if (!lang || lang == "zh") {
      this.translate = this.multiBrandZH;
      this.activeLang = "zh";
    } else if (lang == "en") {
      this.translate = this.multiBrandEn;
      this.activeLang = "en";
    }
    const id = this.$route.query.id;
    // this.projectName = this.$route.query.name;
    // this.projectNameEn = this.$route.query.nameEn;
    // // 判断是否为有效的图片路径
    // const imgParam = this.$route.query.img;
    // const isValidImageSource = imgParam && typeof imgParam === 'string' && imgParam.trim() !== '' && imgParam.trim() !== 'null' && !/^javascript:/i.test(imgParam);
    // if (isValidImageSource) {
    //   this.scadaImg = imgParam;
    // }
    if (id) {
      this.projectId = id;
      // 可以在这里调用其他方法，使用站房ID进行数据请求或处理
      console.log('当前站房ID:', this.projectId);
      this.getStationinfo(id);
      this.getFlowTrendByProject(id);
      this.getPressureTrendByProject(id);
      this.getPowerTrendByProject(id);
      this.getDewPointTrendByProject(id);
      this.getFlowPowerRatioTrendByProject(id);
      this.getSpecificPowerRatioTrendByProject(id);

      this.getSumFlowByProject(id);
      this.getSumPowerByProject(id);
      this.getSumBatteryByProject(id);
      this.getAvgPressureByProject(id);
      this.getAvgDewPointByProject(id);
      this.getAvgSpecificPowerRatioByProject(id);
      this.getSumFlowPowerRatioByProject(id);
      // this.getCardMessage(id)
      this.getThreeTrendByProject(id);
    } else {
      console.warn('未找到站房ID');
    }



    this.$nextTick(() => {
      this.SetMapHeight();
    });

    window.addEventListener("resize", this.SetMapHeight);
  },

  mounted() {
    const rawAccountType = localStorage.getItem('accountType');
    const accountType = rawAccountType ? rawAccountType.trim().replace(/[^a-zA-Z0-9_]/g, '') : '';
    const rawRoles = localStorage.getItem('roles');
    const roles = rawRoles ? rawRoles.trim().replace(/[^a-zA-Z0-9_]/g, '') : '';
    console.log('accountType:', accountType);
    if (accountType === "emcCustomer") {
      this.showBackHomeButton = false;
    }
    if  (roles === "EMCManager") {
      this.showBackHomeButton = false;
    }
  },

  watch: {
    // 监听路由变化，如果路由参数改变，则重新获取站房ID
    // '$route.params.id': function (newId) {
    //   this.projectId = newId;
    //   console.log('站房ID已更新:', this.projectId);
    //   this.getFlowTrendByProject(newId);
    //   this.getPressureTrendByProject(newId);
    //   this.getPowerTrendByProject(newId);
    //   this.getDewPointTrendByProject(newId);
    //   this.getSumFlowByProject(newId);
    //   this.getSumPowerByProject(newId);
    //   this.getAvgPressureByProject(newId);
    //   this.getAvgDewPointByProject(newId);
    //   this.getSpecificPowerRatioTrendByProject(newId);
    //   this.getAvgSpecificPowerRatioByProject(newId);
    //   this.getFlowPowerRatioTrendByProject(id);
    //   this.getSumFlowPowerRatioByProject(id);
      // this.getCardMessage(newId)
    // }
  },

  methods: {
    ...mapMutations(["setLanguage", "setMultiLanguage"]),
    changeLanguage(e) {
      //window.localStorage.setItem("multi_lang", e);
      window.localStorage.setItem("user_lang", e);
      this.setLanguage(e);
      window.location.reload();
    },
    SetMapHeight() {
      var WH = document.documentElement.clientHeight;
      var HTime = parseInt((WH - 290) / 19);
      this.lineChartHeight.height = HTime * 4.3 + "px";
      this.mapHeight.height = WH - 110 + "px";
      // const body = this.$refs.img
      // this.cardHeight.height = WH - body.clientHeight - 60 + "px";
      // console.log('cardHeight', this.cardHeight);
    },

    async getStationinfo(id) {
      let res = await getStationinfo(id);
      if (res.result) {
        this.projectName = res.result.projectName;
        this.projectNameEn = res.result.projectNameEn;
        this.scadaImg = res.result.stationImgUrl;

      }
    },
    async getFlowTrendByProject(id) {
      let res = await getFlowTrendByProject(id);
      console.log('getFlowTrendByProject', res.result);
      if (res.result?.length) {
        const sortedData = [...res.result];
        const chart = echarts.init(document.getElementById('flowTrend'));
        const option = {
          title: {
            text: '',
            left: 'center',
            textStyle: {
              color: '#ddd', // 标题颜色
              fontSize: 12,
              fontWeight: 300
            }
          },
          //边距
          grid: {
            top: 28,
            left: 43,
            right: 12,
            bottom: 28,
          },
          xAxis: {
            type: 'time',
            // data: sortedData.map(d => d.time),
            axisLabel: {
              color: '#ccc', // X轴标签颜色
              // rotate: 40, // 标签旋转角度
              fontSize: 10,
              margin: 15,          // 增加标签间距
              hideOverlap: true,   // 自动隐藏重叠标签
              formatter: (value) => {
                const date = new Date(value);
                const month = String(date.getMonth()).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hour = String(date.getHours()).padStart(2, '0');
                const minute = String(date.getMinutes()).padStart(2, '0');
                return ` ${hour}:${minute} `;
              },
              // interval: (index) => {
              //   // 动态间隔逻辑
              //   const total = res.result.length; // 总数据点数
              //   if (total < 50) return 1;    // 每2个显示1个
              //   if (total < 100) return 3;   // 每4个显示1个
              //   return index % 20 === 0;      // 每10个显示1个（200点显示20个标签）
              // }
            },
            axisLine: {
              lineStyle: {
                color: '#666' // X轴线颜色
              }
            },

            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },

            boundaryGap: false,
          },
          //缩放
          dataZoom: [{
            type: 'inside',
            start: 0,
            end: 100,
            xAxisIndex: 0,
            filterMode: 'filter'
          }],
          yAxis: {
            type: 'value',
            name: 'm³/min',
            nameTextStyle: {
              color: '#ccc' // 单位颜色
            },
            axisLabel: {
              color: '#828393',
              formatter: '{value}', // 单位显示
              textStyle: {
                fontSize: 10,
                fontFamily: "Arial",
              },
            },
            splitLine: {
              lineStyle: {
                color: '#3A3D46' // 网格线颜色
              }
            }
          },
          tooltip: {
            trigger: 'axis',
            backgroundColor: "#141518",
            textStyle: { color: "#fff" },
            formatter: params => {
              const data = params[0];
              const date = new Date(data.value[0]);
              return `
                ${echarts.time.format(date, '{MM}-{dd} {HH}:{mm}', false)}<br>
                ${data.value[1].toFixed(2)} m³/min
              `;
            }
          },
          series: [{
            name: '瞬时流量',
            data: sortedData.map(item => [
              item.time,    // x轴时间
              item.data     // y轴数值
            ]),
            type: 'line',
            sampling: 'lttb',
            progressive: 1000,
            smooth: true,
            showAllSymbol: false,
            symbol: 'none',
            symbolSize: 6,
            itemStyle: {
              color: "rgba(58,64,73,1)",
              borderColor: "rgba(255,255,255,1)",
              borderWidth: 1,
            },
            lineStyle: {
              color: "rgb(255, 255, 255)", // 折线颜色
              width: 2, // 折线宽度
              type: 'solid', // 折线类型（solid、dashed、dotted）
            },
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "rgba(113, 67, 19, 1)" },
                  { offset: 1, color: "rgba(62,96,149,0)" },
                ]),
              },
            },
          }],
        };
        chart.setOption(option);
        window.addEventListener('resize', () => chart.resize());
      } else {
        const chart = echarts.init(document.getElementById('flowTrend'));
        chart.setOption(this.echatsNoDataOption);
      }
    },
    async getPressureTrendByProject(id) {
      let res = await getPressureTrendByProject(id);
      console.log('getPressureTrendByProject', res.result);
      if (res.result?.length) {
        const sortedData = [...res.result];
        const chart = echarts.init(document.getElementById('pressureTrend'));
        const option = {
          title: {
            text: '',
            left: 'center',
            textStyle: {
              color: '#ddd', // 标题颜色
              fontSize: 12,
              fontWeight: 300
            }
          },
          //边距
          grid: {
            top: 28,
            left: 28,
            right: 12,
            bottom: 28,
          },
          xAxis: {
            type: 'time',
            // minInterval: 180 * 60 * 1000,
            axisLabel: {
              color: '#ccc', // X轴标签颜色
              // rotate: 40, // 标签旋转角度
              fontSize: 10,
              margin: 15,          // 增加标签间距
              hideOverlap: true,   // 自动隐藏重叠标签
              formatter: (value) => {
                const date = new Date(value);
                const month = String(date.getMonth()).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hour = String(date.getHours()).padStart(2, '0');
                const minute = String(date.getMinutes()).padStart(2, '0');
                return ` ${hour}:${minute} `;
              },
              // interval: (index) => {
              //   // 动态间隔逻辑
              //   const total = res.result.length; // 总数据点数
              //   if (total < 50) return 200;    // 每2个显示1个
              //   if (total < 100) return 200;   // 每4个显示1个
              //   return index % 200 === 0;      // 每10个显示1个（200点显示20个标签）
              // }

            },
            axisLine: {
              lineStyle: {
                color: '#666' // X轴线颜色
              }
            },

            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },

            boundaryGap: false,
          },
          //缩放
          dataZoom: [{
            type: 'inside',
            start: 0,
            end: 100,
            xAxisIndex: 0,
            filterMode: 'filter'
          }],
          yAxis: {
            type: 'value',
            name: 'bar',
            nameTextStyle: {
              color: '#ccc' // 单位颜色
            },
            axisLabel: {
              color: '#828393',
              formatter: '{value}', // 单位显示
              textStyle: {
                fontSize: 10,
                fontFamily: "Arial",
              },
            },
            splitLine: {
              lineStyle: {
                color: '#3A3D46' // 网格线颜色
              }
            }
          },
          tooltip: {
            trigger: 'axis',
            backgroundColor: "#141518",
            textStyle: { color: "#fff" },
            formatter: params => {
              const data = params[0];
              const date = new Date(data.value[0]);
              return `
                ${echarts.time.format(date, '{MM}-{dd} {HH}:{mm}', false)}<br>
                ${data.value[1].toFixed(2)} bar
              `;
            }
          },
          series: [{
            name: '流量',
            data: sortedData.map(item => [
              item.time,    // x轴时间
              item.data     // y轴数值
            ]),
            type: 'line',
            sampling: 'lttb',
            progressive: 1000,
            smooth: true,
            showAllSymbol: false,
            symbol: 'none',
            symbolSize: 6,
            itemStyle: {
              color: "rgba(58,64,73,1)",
              borderColor: "rgba(255,255,255,1)",
              borderWidth: 1,
            },
            lineStyle: {
              color: "rgb(255, 255, 255)", // 折线颜色
              width: 2, // 折线宽度
              type: 'solid', // 折线类型（solid、dashed、dotted）
            },
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "rgba(113, 67, 19, 1)" },
                  { offset: 1, color: "rgba(62,96,149,0)" },
                ]),
              },
            },
          }],
        };
        chart.setOption(option);
        window.addEventListener('resize', () => chart.resize());
      } else {
        const chart = echarts.init(document.getElementById('pressureTrend'));
        chart.setOption(this.echatsNoDataOption);
      }
    },
    async getPowerTrendByProject(id) {
      let res = await getPowerTrendByProject(id);
      console.log('getPowerTrendByProject', res.result);
      if (res.result?.length) {
        const sortedData = [...res.result];
        const chart = echarts.init(document.getElementById('powerTrend'));
        const option = {
          title: {
            text: '',
            left: 'center',
            textStyle: {
              color: '#ddd', // 标题颜色
              fontSize: 12,
              fontWeight: 300
            }
          },
          //边距
          grid: {
            top: 28,
            left: 48,
            right: 12,
            bottom: 28,
          },
          xAxis: {
            type: 'time',
            axisLabel: {
              color: '#ccc', // X轴标签颜色
              // rotate: 40, // 标签旋转角度
              fontSize: 10,
              margin: 15,          // 增加标签间距
              hideOverlap: true,   // 自动隐藏重叠标签
              formatter: (value) => {
                const date = new Date(value);
                const month = String(date.getMonth()).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hour = String(date.getHours()).padStart(2, '0');
                const minute = String(date.getMinutes()).padStart(2, '0');
                return ` ${hour}:${minute} `;
              },

            },
            axisLine: {
              lineStyle: {
                color: '#666' // X轴线颜色
              }
            },

            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },

            boundaryGap: false,
          },
          //缩放
          dataZoom: [{
            type: 'inside',
            start: 0,
            end: 100,
            xAxisIndex: 0,
            filterMode: 'filter'
          }],
          yAxis: {
            type: 'value',
            name: 'kW',
            nameTextStyle: {
              color: '#ccc' // 单位颜色
            },
            axisLabel: {
              color: '#828393',
              formatter: '{value}', // 单位显示
              textStyle: {
                fontSize: 10,
                fontFamily: "Arial",
              },
            },
            splitLine: {
              lineStyle: {
                color: '#3A3D46' // 网格线颜色
              }
            }
          },
          tooltip: {
            trigger: 'axis',
            backgroundColor: "#141518",
            textStyle: { color: "#fff" },
            formatter: params => {
              const data = params[0];
              const date = new Date(data.value[0]);
              return `
                ${echarts.time.format(date, '{MM}-{dd} {HH}:{mm}', false)}<br>
                ${data.value[1].toFixed(2)} kW
              `;
            }
          },
          series: [{
            name: '流量',
            data: sortedData.map(item => [
              item.time,    // x轴时间
              item.data     // y轴数值
            ]),
            type: 'line',
            sampling: 'lttb',
            progressive: 1000,
            smooth: true,
            showAllSymbol: false,
            symbol: 'none',
            symbolSize: 6,
            itemStyle: {
              color: "rgba(58,64,73,1)",
              borderColor: "rgba(255,255,255,1)",
              borderWidth: 1,
            },
            lineStyle: {
              color: "rgb(255, 255, 255)", // 折线颜色
              width: 2, // 折线宽度
              type: 'solid', // 折线类型（solid、dashed、dotted）
            },
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "rgba(113, 67, 19, 1)" },
                  { offset: 1, color: "rgba(62,96,149,0)" },
                ]),
              },
            },
          }],
        };
        chart.setOption(option);
        window.addEventListener('resize', () => chart.resize());
      } else {
        const chart = echarts.init(document.getElementById('powerTrend'));
        chart.setOption(this.echatsNoDataOption);
      }
    },
    async getDewPointTrendByProject(id) {
      let res = await getDewPointTrendByProject(id);
      console.log('getDewPointTrendByProject', res.result);
      if (res.result?.length) {
        const sortedData = [...res.result];
        const chart = echarts.init(document.getElementById('dewPointTrend'));
        const option = {
          title: {
            text: '',
            left: 'center',
            textStyle: {
              color: '#ddd', // 标题颜色
              fontSize: 12,
              fontWeight: 300
            }
          },
          //边距
          grid: {
            top: 28,
            left: 30,
            right: 12,
            bottom: 28,
          },
          xAxis: {
            type: 'time',
            axisLabel: {
              color: '#ccc', // X轴标签颜色
              // rotate: 40, // 标签旋转角度
              fontSize: 10,
              margin: 15,          // 增加标签间距
              hideOverlap: true,   // 自动隐藏重叠标签
              formatter: (value) => {
                const date = new Date(value);
                // const month = date.getMonth() + 1; // 不补零
                const month = String(date.getMonth()).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hour = String(date.getHours()).padStart(2, '0');
                const minute = String(date.getMinutes()).padStart(2, '0');
                return ` ${hour}:${minute} `;
              },

            },
            axisLine: {
              lineStyle: {
                color: '#666' // X轴线颜色
              }
            },

            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },

            boundaryGap: false,
          },
          //缩放
          dataZoom: [{
            type: 'inside',
            start: 0,
            end: 100,
            xAxisIndex: 0,
            filterMode: 'filter'
          }],
          yAxis: {
            type: 'value',
            name: '°C',
            nameTextStyle: {
              color: '#ccc' // 单位颜色
            },
            axisLabel: {
              color: '#828393',
              formatter: '{value}', // 单位显示
              textStyle: {
                fontSize: 10,
                fontFamily: "Arial",
              },
            },
            splitLine: {
              lineStyle: {
                color: '#3A3D46' // 网格线颜色
              }
            }
          },
          tooltip: {
            trigger: 'axis',
            backgroundColor: "#141518",
            textStyle: { color: "#fff" },
            formatter: params => {
              const data = params[0];
              const date = new Date(data.value[0]);
              return `
                ${echarts.time.format(date, '{MM}-{dd} {HH}:{mm}', false)}<br>
                ${data.value[1].toFixed(2)} °C
              `;
            }
          },
          series: [{
            name: '流量',
            data: sortedData.map(item => [
              item.time,    // x轴时间
              item.data     // y轴数值
            ]),
            type: 'line',
            sampling: 'lttb',
            progressive: 1000,
            smooth: true,
            showAllSymbol: false,
            symbol: 'none',
            symbolSize: 6,
            itemStyle: {
              color: "rgba(58,64,73,1)",
              borderColor: "rgba(255,255,255,1)",
              borderWidth: 1,
            },
            lineStyle: {
              color: "rgb(255, 255, 255)", // 折线颜色
              width: 2, // 折线宽度
              type: 'solid', // 折线类型（solid、dashed、dotted）
            },
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "rgba(113, 67, 19, 1)" },
                  { offset: 1, color: "rgba(62,96,149,0)" },
                ]),
              },
            },
          }],
        };
        chart.setOption(option);
        window.addEventListener('resize', () => chart.resize());
      } else {
        const chart = echarts.init(document.getElementById('dewPointTrend'));
        chart.setOption(this.echatsNoDataOption);
      }
    },

    async getSumFlowByProject(id) {
      await getSumFlowByProject(id).then(res => {
        console.log('getSumFlowByProject', res);
        this.sumFlow = res ? res.result : '--';
      }).catch(() => {
        this.sumFlow = '- -';
      });
    },

    async getSumPowerByProject(id) {
      await getSumPowerByProject(id).then(res => {
        console.log('getSumPowerByProject', res);
        this.sumPower = res ? res.result : '--';
      }).catch(error => {
        this.sumPower = '- -';
      });
    },

    async getSumBatteryByProject(id) {
      await getSumBatteryByProject(id).then(res => {
        console.log('getSumBatteryByProject', res);
        this.sumBattery = res ? res.result : '--';
      }).catch(error => {
        this.sumBattery = '- -';
      });
    },

    async getAvgPressureByProject(id) {
      await getAvgPressureByProject(id).then(res => {
        console.log('getAvgPressureByProject', res);
        this.avgPressure = res ? res.result : '--';
      }).catch(error => {
        this.avgPressure = '- -';
      });
    },

    async getAvgDewPointByProject(id) {
      await getAvgDewPointByProject(id).then(res => {
        console.log('getAvgDewPointByProject', res);
        this.avgDewPoint = res ? res.result : '--';
      }).catch(error => {
        this.avgDewPoint = '- -';
      });
    },

    async getAvgSpecificPowerRatioByProject(id) {
      await getAvgSpecificPowerRatioByProject(id).then(res => {
        console.log('getAvgSpecificPowerRatioByProject', res);
        this.avgSpecificPowerRatio = res ? res.result : '--';
      }).catch(error => {
        this.avgSpecificPowerRatio = '- -';
      });
    },

    async getSpecificPowerRatioTrendByProject(id) {
      let res = await getSpecificPowerTrendByProject(id);
      console.log('getSpecificPowerTrendByProject', res.result);
      if (res.result?.length) {
        const sortedData = [...res.result];
        const chart = echarts.init(document.getElementById('specificPowerRatioTrend'));
        const option = {
          title: {
            text: '',
            left: 'center',
            textStyle: {
              color: '#ddd', // 标题颜色
              fontSize: 12,
              fontWeight: 300
            }
          },
          //边距
          grid: {
            top: 28,
            left: 44,
            right: 12,
            bottom: 28,
          },
          xAxis: {
            type: 'time',
            axisLabel: {
              color: '#ccc', // X轴标签颜色
              // rotate: 40, // 标签旋转角度
              fontSize: 10,
              margin: 15,          // 增加标签间距
              hideOverlap: true,   // 自动隐藏重叠标签
              formatter: (value) => {
                const date = new Date(value);
                // const month = date.getMonth() + 1; // 不补零
                const month = String(date.getMonth()).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hour = String(date.getHours()).padStart(2, '0');
                const minute = String(date.getMinutes()).padStart(2, '0');
                return ` ${hour}:${minute} `;
              },

            },
            axisLine: {
              lineStyle: {
                color: '#666' // X轴线颜色
              }
            },

            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },

            boundaryGap: false,
          },
          //缩放
          dataZoom: [{
            type: 'inside',
            start: 0,
            end: 100,
            xAxisIndex: 0,
            filterMode: 'filter'
          }],
          yAxis: {
            type: 'value',
            name: 'kW/(m³/min)',
            nameTextStyle: {
              color: '#ccc' // 单位颜色
            },
            axisLabel: {
              color: '#828393',
              formatter: '{value}', // 单位显示
              textStyle: {
                fontSize: 10,
                fontFamily: "Arial",
              },
            },
            splitLine: {
              lineStyle: {
                color: '#3A3D46' // 网格线颜色
              }
            }
          },
          tooltip: {
            trigger: 'axis',
            backgroundColor: "#141518",
            textStyle: { color: "#fff" },
            formatter: params => {
              const data = params[0];
              const date = new Date(data.value[0]);
              return `
                ${echarts.time.format(date, '{MM}-{dd} {HH}:{mm}', false)}<br>
                ${data.value[1]} kW/(m³/min)
              `;
            }
          },
          series: [{
            name: '比功率',
            data: sortedData.map(item => [
              item.time,    // x轴时间
              item.data     // y轴数值
            ]),
            type: 'line',
            sampling: 'lttb',
            progressive: 1000,
            smooth: true,
            showAllSymbol: false,
            symbol: 'none',
            symbolSize: 6,
            itemStyle: {
              color: "rgba(58,64,73,1)",
              borderColor: "rgba(255,255,255,1)",
              borderWidth: 1,
            },
            lineStyle: {
              color: "rgb(255, 255, 255)", // 折线颜色
              width: 2, // 折线宽度
              type: 'solid', // 折线类型（solid、dashed、dotted）
            },
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "rgba(113, 67, 19, 1)" },
                  { offset: 1, color: "rgba(62,96,149,0)" },
                ]),
              },
            },
          }],
        };
        chart.setOption(option);
        window.addEventListener('resize', () => chart.resize());
      } else {
        const chart = echarts.init(document.getElementById('specificPowerRatioTrend'));
        chart.setOption(this.echatsNoDataOption);
      }
    },

    async getSumFlowPowerRatioByProject(id) {
      await getSumFlowPowerRatioByProject(id).then(res => {
        console.log('getSumFlowPowerRatioByProject', res);
        this.sumFlowPowerRatio = res ? res.result : '--';
      }).catch(error => {
        this.sumFlowPowerRatio = '- -';
      });
    },

    async getFlowPowerRatioTrendByProject(id) {
      let res = await getFlowPowerRatioTrendByProject(id);
      console.log('getFlowPowerRatioTrendByProject', res.result);
      if (res.result?.length) {
        const sortedData = [...res.result];
        const chart = echarts.init(document.getElementById('flowPowerRatioTrend'));
        const option = {
          title: {
            text: '',
            left: 'center',
            textStyle: {
              color: '#ddd', // 标题颜色
              fontSize: 12,
              fontWeight: 300
            }
          },
          //边距
          grid: {
            top: 28,
            left: 38,
            right: 12,
            bottom: 28,
          },
          xAxis: {
            type: 'time',
            axisLabel: {
              color: '#ccc', // X轴标签颜色
              // rotate: 40, // 标签旋转角度
              fontSize: 10,
              margin: 15,          // 增加标签间距
              hideOverlap: true,   // 自动隐藏重叠标签
              formatter: (value) => {
                const date = new Date(value);
                // const month = date.getMonth() + 1; // 不补零
                const month = String(date.getMonth()).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hour = String(date.getHours()).padStart(2, '0');
                const minute = String(date.getMinutes()).padStart(2, '0');
                return ` ${hour}:${minute} `;
              },

            },
            axisLine: {
              lineStyle: {
                color: '#666' // X轴线颜色
              }
            },

            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },

            boundaryGap: false,
          },
          //缩放
          dataZoom: [{
            type: 'inside',
            start: 0,
            end: 100,
            xAxisIndex: 0,
            filterMode: 'filter'
          }],
          yAxis: {
            type: 'value',
            name: 'kWh/m³',
            nameTextStyle: {
              color: '#ccc' // 单位颜色
            },
            axisLabel: {
              color: '#828393',
              formatter: '{value}', // 单位显示
              textStyle: {
                fontSize: 10,
                fontFamily: "Arial",
              },
            },
            splitLine: {
              lineStyle: {
                color: '#3A3D46' // 网格线颜色
              }
            }
          },
          tooltip: {
            trigger: 'axis',
            backgroundColor: "#141518",
            textStyle: { color: "#fff" },
            formatter: params => {
              const data = params[0];
              const date = new Date(data.value[0]);
              return `
                ${echarts.time.format(date, '{MM}-{dd} {HH}:{mm}', false)}<br>
                ${data.value[1]} kWh/m³
              `;
            }
          },
          series: [{
            name: '气电比',
            data: sortedData.map(item => [
              item.time,    // x轴时间
              item.data     // y轴数值
            ]),
            type: 'line',
            sampling: 'lttb',
            progressive: 1000,
            smooth: true,
            showAllSymbol: false,
            symbol: 'none',
            symbolSize: 6,
            itemStyle: {
              color: "rgba(58,64,73,1)",
              borderColor: "rgba(255,255,255,1)",
              borderWidth: 1,
            },
            lineStyle: {
              color: "rgb(255, 255, 255)", // 折线颜色
              width: 2, // 折线宽度
              type: 'solid', // 折线类型（solid、dashed、dotted）
            },
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "rgba(113, 67, 19, 1)" },
                  { offset: 1, color: "rgba(62,96,149,0)" },
                ]),
              },
            },
          }],
        };
        chart.setOption(option);
        window.addEventListener('resize', () => chart.resize());
      } else {
        const chart = echarts.init(document.getElementById('flowPowerRatioTrend'));
        chart.setOption(this.echatsNoDataOption);
      }
    },

    async getThreeTrendByProject(id) {
      // 并行请求三条数据
      const [flowRes, powerRes, unitRes] = await Promise.all([
        getFlowStatisticsThrendByProject(id),
        getPowerStatisticsThrendByProject(id),
        getUnitConsumptionStatisticsThrendByProject(id)
      ]);

      console.log('流量趋势:', flowRes.result);
      console.log('电量趋势:', powerRes.result);
      console.log('单耗趋势:', unitRes.result);

      // 检查是否有任意一组数据存在
      if ([flowRes.result, powerRes.result, unitRes.result].some(arr => arr?.length)) {
        // const sortedData = [...res.result];
        const chart = echarts.init(document.getElementById('threeTrend'));
        const colors = [ '#91CC75', '#5571C7', '#EE6666'];
        const option = {
          color: colors,
          title: {
            text: '',
            left: 'center',
            textStyle: {
              color: '#ddd', // 标题颜色
              fontSize: 12,
              fontWeight: 300
            }
          },
          //边距
          grid: {
            top: 58,
            left: 98,
            right: 200,
            bottom: 28,
          },
          legend: {
            data: ['单耗', '电量', '流量'],
            textStyle: { color: "#ccc" },
          },
          xAxis: {
            type: 'category',
            axisLabel: {
              color: '#ccc', // X轴标签颜色
              // rotate: 40, // 标签旋转角度
              fontSize: 10,
              margin: 15,          // 增加标签间距
              hideOverlap: true,   // 自动隐藏重叠标签
              // formatter: (value) => {
              //   const date = new Date(value);
              //   // const month = date.getMonth() + 1; // 不补零
              //   const month = String(date.getMonth()).padStart(2, '0');
              //   const day = String(date.getDate()).padStart(2, '0');
              //   const hour = String(date.getHours()).padStart(2, '0');
              //   const minute = String(date.getMinutes()).padStart(2, '0');
              //   return ` ${hour}:${minute} `;
              // },
            },
            axisLine: {
              lineStyle: {
                color: '#666' // X轴线颜色
              }
            },

            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },

            boundaryGap: false,
          },
          //缩放
          dataZoom: [
            {
              type: 'inside',
              start: 0,
              end: 100,
              xAxisIndex: 0,
              filterMode: 'filter'
            }],

          yAxis: [
            {
              type: 'value',
              name: '单耗 kWh/m³',
              position: 'left',
              alignTicks: true,
              yAxisIndex: 0, // 绑定到第一个Y轴
              nameTextStyle: {
                color: colors[0] // 单位颜色
              },
              axisLine: {
                show: true,
                lineStyle: {
                  color: colors[0]
                }
              },
              axisLabel: {
                color: colors[0],
                formatter: '{value}', // 单位显示
              },
              splitLine: {
                lineStyle: {
                  color: '#3A3D46' // 网格线颜色
                }
              }
            },
            {
              type: 'value',
              name: '电量 kWh',
              position: 'right',
              alignTicks: true,
              yAxisIndex: 1, // 绑定到第2个Y轴
              axisLine: {
                show: true,
                lineStyle: {
                  color: colors[2]
                }
              },
              axisLabel: {
                color: colors[2],
                formatter: '{value}', // 单位显示
              },
              splitLine: {
                lineStyle: {
                  color: '#3A3D46' // 网格线颜色
                }
              }
            },
            {
              type: 'value',
              name: '流量 m³',
              position: 'right',
              yAxisIndex: 2, // 绑定到第3个Y轴
              offset: 80,
              alignTicks: true,
              nameTextStyle: {
                color: colors[1] // 单位颜色
              },
              axisLine: {
                show: true,
                lineStyle: {
                  color: colors[1]
                }
              },
              axisLabel: {
                color: colors[1],
                formatter: '{value}', // 单位显示
              },
              splitLine: {
                lineStyle: {
                  color: '#3A3D46' // 网格线颜色
                }
              }
            },
          ],
          tooltip: {
            trigger: 'axis',
            backgroundColor: "#141518",
            textStyle: { color: "#fff" },
            // formatter: params => {
            //   const data = params[0];
            //   const date = new Date(data.value[0]);
            //   return `
            //     ${echarts.time.format(date, '{MM}-{dd} {HH}:{mm}', false)}<br>
            //     ${data.value[1]} kWh/m³<br>
            //     ${data.value[2]} kWh/m³<br>
            //   `;
            // }
          },
          toolbox: {
            feature: {
              dataView: { show: false, readOnly: false },
              restore: { show: true },
              saveAsImage: { show: false }
            }
          },
          series: [
            {
              name: '单耗',
              yAxisIndex: 0, // 绑定到第一个Y轴
              data: unitRes.result.map(item => [item.time, parseFloat(item.data.toFixed(4))]),
              type: 'line',
              smooth: true,
              showAllSymbol: false,
              symbol: 'none',
              symbolSize: 6,
            },
            {
              name: '流量',
              yAxisIndex: 1, // 绑定到第2个Y轴
              data: flowRes.result.map(item => [item.time, item.data]),
              type: 'line',
              smooth: true,
              symbol: 'none',
              symbolSize: 6,
            },
            {
              name: '电量',
              yAxisIndex: 2, // 绑定到第3个Y轴
              data: powerRes.result.slice(Math.max(powerRes.result.length - 30, 0)).map(item => [item.time, item.data]),
              type: 'line',
              smooth: true,
              showAllSymbol: false,
              symbol: 'none',
              symbolSize: 6,
            },
          ],
        };
        chart.setOption(option);
        window.addEventListener('resize', () => chart.resize());
      } else {
        const chart = echarts.init(document.getElementById('threeTrend'));
        chart.setOption(this.echatsNoDataOption);
      }
    },

    async getCardMessage(id) {
      await getProjectMonitorData(id).then(res => {
        console.log('getCardMessage', res.result);
        this.cardMessage = res.result.monitorDatas;
        console.log('this.cardMessage', this.cardMessage);
      }).catch(error => {
        this.cardMessage = [];
      });
    },

    retHome() {
      //this.$router.push({ path: "/index" });      
      window.location.href = "/index";
    },

    translateResourceType(name) {
      return this.$t('city.' + name).indexOf(".") > -1 ? name : this.$t('city.' + name)
    },

    formatNumber(num) {
      if (!num) return num;
      const numStr = num.toString();
      const [integerPart, decimalPart] = numStr.split('.');
      if (integerPart.length > 3) {
        const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return formattedInteger;
      }
      // 处理不超过3位整数的情况
      return decimalPart ? numStr : num.toFixed(1);
    },

    extractValidTextAfterDelimiter(str) {
      if (!str || typeof str !== 'string') return str || '';
      // 匹配第一个空格或下划线后的非空内容
      const match = str.match(/[ _]+(.+)/);
      // 如果匹配成功且捕获组不为空，则返回捕获组内容（已trim），否则返回原字符串
      return match?.[1]?.trim() || str;
    }

  },
};
</script>

<style lang="less" scope>
body {
  padding: 0;
  margin: 0;
  color: #fff;
}

.BoxTitle {
  margin: 0 !important;
  font-size: 17px !important;
}

.theme1 {
  .backHome {
    width: auto !important;
    //   height: 26px !important;
    padding: 0px 10px !important;
    font-size: 12px !important;
    //  //  line-height: 27px;
    //margin-top: 31px;
    // margin-left: 29px;
    background: rgba(255, 255, 255, 0.3) !important;

    i {
      color: #fff;
      margin-right: 5px;
    }

    span {
      margin: 0 !important;
      font-size: 13px !important;
      line-height: 25px !important;
      padding: 0;
      color: #fff;
    }
  }

  // .rightSide {
  //   top: 0;
  //   left: 0;
  // }

  .Large-Header {
    text-align: center;
    height: 90px !important;
    z-index: 2;

    img {
      height: 46px;
      margin: 16px 0 0 30px;
      float: left;
    }

    span {
      display: inline-block;
      font-size: 24px;
      font-weight: 600;
      margin-top: 15px;
      line-height: 45px;
      margin-left: -192px;
      margin-right: -258px;

      small {
        display: block;
        font-size: 12px;
        margin: 0;
        line-height: 14px;
        color: #828393;
      }
    }
  }

  .Large-index {
    padding-top: 90px !important;
  }

  .el-row {
    margin-left: -10px !important;
    margin-right: -10px !important;
  }

  .el-col {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }

  s .el-table--small {

    td,
    th {
      padding: 9px 2px;
    }
  }

  /* 卡片容器 */
  .el-card {
    background-color: #222; // 深色背景
    border: 2px solid #55381a; // 调整边框颜色
    border-radius: 12px;
    margin-block: 10px;
    color: #fff; // 主文字颜色
    margin: 8px;

    /* 卡片标题 */
    .el-card__header {
      background-color: #222; // 标题栏背景
      border-bottom: 1px solid #55381a; // 标题分割线
      color: #fff;
      font-size: 15px;
      font-weight: bold;
      padding: 10px 15px 10px 15px;
    }

    /* 卡片正文 */
    .el-card__body {
      color: #eee; // 正文文字颜色
      font-size: 15px;
      padding: 9px 5px 10px 15px;
      overflow-y: auto;

      // 设置滚动条样式
      &::-webkit-scrollbar {
        width: 5px !important;
      }

      .cardItem {
        font-size: 13px;
        line-height: 18px;
      }
    }

    /* 鼠标悬停效果 */
    &:hover {
      box-shadow: 0 2px 12px 0 rgba(255, 255, 255, 0.1); // 浅色阴影
    }
  }

  .card-carousel-container {
    height: 295px;
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 10px;

    // 设置滚动条样式
    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 6px;
      /* 圆角更美观 */
      transition: all 0.3s;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #a8a8a8;
    }

    &::-webkit-scrollbar-button {
      // display: block;
      color: #cdc2c2;
    }
  }

  .el-table {
    .el-table__body {
      tr {
        td {
          border-radius: 0 !important;
          background-color: rgba(0, 0, 0, 0);
        }
      }
    }

    tr {
      border-radius: 0 !important;
      background-color: rgba(0, 0, 0, 0);
    }

    .cell {
      padding: 0 0px;
    }

    .strong {
      .cell {
        color: #fff;
        font-weight: bold;
      }
    }
  }

  // 客户列表样式
  .homeCon {
    padding: 8px 15px;
    border-radius: 8px;
    margin-bottom: 20px;
  }

  .el-table__body-wrapper {
    overflow-y: auto;
    /* 确保表格内容可以滚动 */
  }

  .clickable {
    cursor: pointer;
    text-decoration: none;
    /* 默认无下划线 */
  }

  .clickable:hover {
    text-decoration: underline;
    /* 鼠标悬浮时加下划线 */
  }

  .InstallTotal {
    position: absolute;
    bottom: 12px;
    right: 20px;
    left: 20px;
    margin: 0;
    padding: 0;
    list-style: none;
    font-size: 12px;

    li {
      line-height: 14px;
      padding: 8px 0;

      span.name {
        display: inline-block;
        font-weight: bold;
        color: #fff;
        width: calc(100% - 120px);
      }

      span.num {
        display: inline-block;
        color: #fff;
        width: 120px;
        text-align: right;

        small {
          font-size: 12px;
          color: rgba(255, 255, 255, 0.5);
          margin: 0 5px;
        }
      }
    }
  }

  .HealthRateUl {
    margin: 0;
  }

  .rightsideDiv {
    border-left: 0;
  }

  .homeConNoBG {
    padding-left: 0px;
  }

  .Large-language {
    float: right;
    margin-top: 22px;

    .el-button {
      height: 22px;
      border: 0px;
      width: 74px;
      padding: 0;
      background: none;

      span {
        line-height: 20px;
        font-size: 12px;
        margin: 0;
      }
    }

    .el-button.selected {
      background-color: #00759b;

      span {
        color: #fff;
      }
    }
  }

  .homeConOpacity {
    background-color: rgba(19, 20, 24, 0.9);
  }

  .titleBgColor {
    // 背景颜色由左往右渐变
    background: linear-gradient(to right,
        #98540a,
        #3e2e1f);
  }

  .fr {
    font-weight: 600;
  }

  .custom-height-img {
    height: 100%;
    width: 100%;
    margin-bottom: 1px;
    margin-top: -10px;
  }

  .cardItem {
    font-size: 14px;
  }
}
</style>
